var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 52,
    viewBox: "0 0 35 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 52C27.7083 40.0209 35 27.703 35 17.6836V16.4901H15.9688V30.6204H19.6146V20.1885H31.0771C30.0417 27.983 24.7917 36.9562 17.5 46.0768C9.58125 35.9837 3.99584 26.038 3.99584 17.6836C3.96143 14.6572 4.91966 11.7045 6.72098 9.28622C8.5223 6.86796 11.0653 5.12029 13.9532 4.31597C16.841 3.51165 19.9112 3.69594 22.6845 4.84008C25.4578 5.98423 27.7781 8.02384 29.2833 10.6406L32.5938 8.62197C31.065 5.95783 28.8601 3.75432 26.2066 2.23903C23.5532 0.723733 20.5475 -0.0484089 17.5 0.00235061C12.8587 0.00235061 8.40752 1.8652 5.12563 5.18108C1.84375 8.49696 0 12.9943 0 17.6836C0 27.703 7.29167 40.0209 17.5 52Z",
    fill: "#1D1D1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGt);
export default __webpack_public_path__ + "static/media/gt.8a1f79bb.svg";
export { ForwardRef as ReactComponent };